export default __webpack_public_path__ + "media/images/fx_factures_red-5a966503f1b3edd8ef3b6ba020941959.png";